import KunLoading25 from './src/index'

KunLoading25.install = function (Vue) {
	Vue.component(KunLoading25.name, KunLoading25);
}

export default KunLoading25;
